import React from 'react';
import Image from 'next/image';
import CTA from 'react-scale/components/ui/cta';
import Section from 'react-scale/components/ui/section';
import cx from 'classnames';

function brandPanelWithScreenshot({ img, title, text, cta, inverted }) {
  return (
    <Section>
      <div className="relative text-white ">
        <div
          className={cx(
            { 'flex-row-reverse': inverted },
            'flex flex-wrap items-center gap-12 px-10 py-10 md:px-20 md:flex-nowrap bg-codGray rounded-3xl'
          )}
          style={{ boxShadow: 'inset 0 4px 0 0 #262626' }}
        >
          <div className="w-full md:w-5/12">
            <Image fill="fill" src={img} width={730} height={720} />
          </div>
          <div className="w-full md:w-7/12">
            <h4 className="mb-6 text-3xl font-normal md:font-light md:text-4xl lg:text-5xl font-aeonik">
              {title}
            </h4>
            <p className="mb-12 text-lg">{text}</p>
            <div className="xl:w-5/6">
              <CTA cta={cta} />
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}

brandPanelWithScreenshot.defaultProps = {
  img: '/static/images/pages/homepage/contact/enterprise-ai.png',
  title: (
    <div>
      <span className="lg:block">Interested in</span> <span className="text-gradient">Rapid</span>{' '}
      labels
      <span className="lg:block">for your model?</span>
    </div>
  ),
  text: 'Sign up for the fastest way to production-quality labeled data.',
  cta: {
    buttons: [
      {
        text: 'Create Your Account',
        href: '/signup',
        variant: 'primary'
      }
    ]
  }
};

export default brandPanelWithScreenshot;
